export const TAXPRO_NOTES_ACTION_TYPE = {
	setLoading: 'taxproNotes/setLoading',
	setNotes: 'taxproNotes/setNotes',
	clearNotes: 'taxproNotes/clearNotes',
	setError: 'taxproNotes/setError',
};

// Keep in sync with backend app/utility/noteTypes.js
export const NOTE_TYPE = Object.freeze({
	EXTEND_FREE_TRIAL: 0,
	INTERNAL_CHECKOUT: 1,
	GENERAL: 2,
});

export const NOTE_TYPE_LABELS = Object.freeze({
	[NOTE_TYPE.EXTEND_FREE_TRIAL]: 'Extend Free Trial',
	[NOTE_TYPE.INTERNAL_CHECKOUT]: 'Internal Checkout',
	[NOTE_TYPE.GENERAL]: 'General',
});
